import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

import ChartStockFinacial from '../../chart/chartStockFinacial';

import * as _ from 'lodash';
import { getQ } from 'utils';

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function FinacialStock(props) {
  const { freqActive, setFreqActive, fsRatio, t, theme } = props;

  const [tongTaisan, setTongTaiSan] = React.useState([]);
  const [noNganHan, setNoNganHan] = React.useState([]);
  const [noDaiHan, setNoDaiHan] = React.useState([]);
  const [vonChuSH, setVonChuSH] = React.useState([]);

  const preFSRatio = usePrevious(fsRatio);

  React.useEffect(() => {
    if (fsRatio && !_.isEqual(fsRatio, preFSRatio)) {
      processData();
    }
  }, [fsRatio]);

  function processData() {
    const _tongTaiSan = _.map(fsRatio, 'TOT_ASSETS');
    const _noNganHan = _.map(fsRatio, 'CURR_LIAB');
    const _noDaiHan = _.map(fsRatio, 'NON_CURR_LIAB');
    const _vonChuSH = _.map(fsRatio, 'TOT_EQUITY');

    const _time = _.map(fsRatio, 'REPORT_DATE');

    let __tongTaiSan = [],
      __noNganHan = [],
      __noDaiHan = [],
      __vonChuSH = [];

    // log(_time);

    for (let index = 0; index < _time.length; index++) {
      if (freqActive === 'Q') {
        __tongTaiSan.push({
          name: getQ(_time[index]),
          value: _tongTaiSan[index],
        });
        __noNganHan.push({
          name: getQ(_time[index]),
          value: _noNganHan[index],
        });
        __noDaiHan.push({
          name: getQ(_time[index]),
          value: _noDaiHan[index],
        });
        __vonChuSH.push({
          name: getQ(_time[index]),
          value: _vonChuSH[index],
        });
      } else {
        let st = new Date(_time[index].replace(/-/g, "/"));
        __tongTaiSan.push({
          name: st.getFullYear() + '',
          value: _tongTaiSan[index],
        });
        __noNganHan.push({
          name: st.getFullYear() + '',
          value: _noNganHan[index],
        });
        __noDaiHan.push({
          name: st.getFullYear() + '',
          value: _noDaiHan[index],
        });
        __vonChuSH.push({
          name: st.getFullYear() + '',
          value: _vonChuSH[index],
        });
      }
    }
    setTongTaiSan(__tongTaiSan);
    setNoNganHan(__noNganHan);
    setNoDaiHan(__noDaiHan);
    setVonChuSH(__vonChuSH);
  }

  // log(fsRatio);

  return (
    <div
      className="d-flex flex-column w-100 h-100 p-2 analysis-overview"
      style={{ background: 'var(--bg_card_chart)', borderRadius: '2px' }}
    >
      <div className="d-flex pb-2" style={{ flexDirection: 'row-reverse' }}>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Y' ? 'active' : '')
          }
          onClick={() => setFreqActive('Y')}
        >
          {t('algo.ptcp.txt-Year')}
        </Button>
        <Button
          variant="info"
          className={
            'fz-14 btn-analysis ' + (freqActive === 'Q' ? 'active' : '')
          }
          onClick={() => setFreqActive('Q')}
        >
          {t('algo.ptcp.txt-Quarter')}
        </Button>
      </div>
      <div
        className="d-grid h-100"
        style={{
          gridTemplateColumns: 'repeat(2, minmax(0px, 1fr))',
          gap: '15px',
        }}
      >
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Total-assets')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={tongTaisan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Current-liabilities')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noNganHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Non-current-liabilities')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={noDaiHan}
            theme={theme}
          />
        </div>
        <div
          style={{
            background: theme === 'dark' ? '#181625' : '#ffffff',
            borderRadius: '4px',
            padding: '15px',
            height: 'calc(50vh - 150px)',
          }}
        >
          <ChartStockFinacial
            titleText={t('algo.ptcp.txt-Total-equity')}
            subText={t('algo.ptcp.txt-bil-vnd')}
            data={vonChuSH}
            theme={theme}
          />
        </div>
      </div>
    </div>
  );
}

export default memo(FinacialStock);
